import { ReactElement } from "react";
import styles from "./SubNavigationLoadingIndicator.module.less";

export const SubNavigationLoadingIndicator = (): ReactElement => {

	return (
		<div className={styles.root}>
			<div>
				<div className={styles.line} />
				<div className={styles.line} />
				<div className={styles.line} />
			</div>
		</div>
	);
};

SubNavigationLoadingIndicator.displayName="SubNavigation.LoadingIndicator";